<ng2-completer #completerWidget
               [textNoResults]=""
               class="completer-limit"
               [datasource]="completerData"
               [minSearchLength]="0"
               [inputClass]="'form-control border-no-radius'"
               [openOnFocus]="true"
               [openOnClick]="false"
               [autoMatch]="true"
               [autoHighlight]="true"
               [fillHighlighted]="false"
               [autofocus]="hasfocus"
               [clearUnselected]="true"
               [(ngModel)]="value"
               (selected)="onSelected($event)"
               (opened)="onOpened($event)"
               (click)="onClick()">
</ng2-completer>
